'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var PreAction = {
  STOP: 0x00,
  MOVE_FORWARD: 0x01,
  MOVE_BACKWARD: 0x02,
  TURN_LEFT: 0x03,
  TURN_RIGHT: 0x04,
  ACTION_UNKNOWN: 0xFF
};
var TelliotBase = /*#__PURE__*/function () {
  function TelliotBase() {
    (0, _classCallCheck2["default"])(this, TelliotBase);
    (0, _defineProperty2["default"])(this, "afterReceive", function (data) {
      var _this = this;
      var keys = data.state ? Object.keys(data.state) : [];
      keys.forEach(function (key) {
        _this.state[key] = data.state[key];
        // console.log(typeof (this.state.sensors));
      });

      // console.log('[afterReceive] : ' + keys);
      // console.log('[afterReceive] : ', data.state);
    });
    (0, _defineProperty2["default"])(this, "afterSend", function () {
      this.resetState();
      Entry.hw.sendQueue = {};
    });
    this.resetState();
  }
  return (0, _createClass2["default"])(TelliotBase, [{
    key: "setZero",
    value: function setZero() {
      this.resetState();
      Entry.hw.update();
    }
  }, {
    key: "resetState",
    value: function resetState() {
      this.state = {
        sensors: 0,
        rfid: []
      };
    }
  }, {
    key: "delay",
    value: function () {
      var _delay = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(ms) {
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (resolve) {
                return setTimeout(resolve, ms);
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function delay(_x) {
        return _delay.apply(this, arguments);
      }
      return delay;
    }()
  }, {
    key: "request",
    value: function () {
      var _request = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(func, subkey, value) {
        var updateNow,
          test,
          _args2 = arguments;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              updateNow = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : false;
              test = [];
              if (!Entry.hw.sendQueue[func]) Entry.hw.sendQueue[func] = {};
              if (subkey) {
                Entry.hw.sendQueue[func][subkey.toString()] = value;
              } else {
                Entry.hw.sendQueue[func] = value;
              }
              console.log('[' + func + '] : ' + value);
              console.log(test);
              if (updateNow) Entry.hw.update();

              // 딜레이 추가
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function request(_x2, _x3, _x4) {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }, {
    key: "req_add_chatbot",
    value: function () {
      var _req_add_chatbot = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(sprite, script) {
        var ask, resp;
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              ask = script.getStringValue('AI_CHATBOT_ASK');
              resp = script.getStringValue('AI_CHATBOT_RESP');
              console.log('[req_chatbot] : ' + ask + ' => ' + resp);
              _context3.next = 1;
              return this.request('add_chatbot', null, {
                ask: ask,
                resp: resp
              }, true);
            case 1:
              return _context3.abrupt("return", script.callReturn());
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function req_add_chatbot(_x5, _x6) {
        return _req_add_chatbot.apply(this, arguments);
      }
      return req_add_chatbot;
    }()
  }, {
    key: "req_voice_trigger",
    value: function () {
      var _req_voice_trigger = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(sprite, script) {
        return _regenerator["default"].wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 1;
              return this.request('req_voice_trigger_click', null, 1);
            case 1:
              return _context4.abrupt("return", script.callReturn());
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function req_voice_trigger(_x7, _x8) {
        return _req_voice_trigger.apply(this, arguments);
      }
      return req_voice_trigger;
    }()
  }, {
    key: "req_speech_to_text",
    value: function () {
      var _req_speech_to_text = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(sprite, script) {
        return _regenerator["default"].wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 1;
              return this.request('req_stt', null, 1);
            case 1:
              return _context5.abrupt("return", script.callReturn());
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function req_speech_to_text(_x9, _x0) {
        return _req_speech_to_text.apply(this, arguments);
      }
      return req_speech_to_text;
    }()
  }, {
    key: "req_text_to_speech",
    value: function () {
      var _req_text_to_speech = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(sprite, script) {
        var stot;
        return _regenerator["default"].wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              stot = script.getStringValue('TEXT_TO_SPEECH');
              console.log('[req_tts] : ' + stot);
              _context6.next = 1;
              return this.request('req_tts', null, stot, true);
            case 1:
              _context6.next = 2;
              return this.delay(3000);
            case 2:
              return _context6.abrupt("return", script.callReturn());
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function req_text_to_speech(_x1, _x10) {
        return _req_text_to_speech.apply(this, arguments);
      }
      return req_text_to_speech;
    }()
  }, {
    key: "req_add_prompt",
    value: function () {
      var _req_add_prompt = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(sprite, script) {
        var ai_prompt;
        return _regenerator["default"].wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              ai_prompt = script.getStringValue('AI_PROMPT');
              console.log('[add_prompt] : ' + ai_prompt);
              _context7.next = 1;
              return this.request('add_prompt', null, ai_prompt, true);
            case 1:
              return _context7.abrupt("return", script.callReturn());
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function req_add_prompt(_x11, _x12) {
        return _req_add_prompt.apply(this, arguments);
      }
      return req_add_prompt;
    }()
  }, {
    key: "req_predefined_action",
    value: function () {
      var _req_predefined_action = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(sprite, script) {
        var action_stridx, action_value, action_id, _t;
        return _regenerator["default"].wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              action_stridx = script.getStringValue('PREDEFINED_MOTION_ID');
              action_value = script.getNumberValue('PREDEFINED_MOTION_VALUE');
              action_id = PreAction.ACTION_UNKNOWN;
              _t = action_stridx;
              _context8.next = _t === 'forward' ? 1 : _t === 'backward' ? 2 : _t === 'left' ? 3 : _t === 'right' ? 4 : 5;
              break;
            case 1:
              action_id = PreAction.MOVE_FORWARD;
              return _context8.abrupt("continue", 5);
            case 2:
              action_id = PreAction.MOVE_BACKWARD;
              return _context8.abrupt("continue", 5);
            case 3:
              action_id = PreAction.TURN_LEFT;
              return _context8.abrupt("continue", 5);
            case 4:
              action_id = PreAction.TURN_RIGHT;
              return _context8.abrupt("continue", 5);
            case 5:
              _context8.next = 6;
              return this.request('pre_action', null, {
                action_id: action_id,
                action_value: action_value
              }, true);
            case 6:
              _context8.next = 7;
              return this.delay(1250);
            case 7:
              return _context8.abrupt("return", script.callReturn());
            case 8:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function req_predefined_action(_x13, _x14) {
        return _req_predefined_action.apply(this, arguments);
      }
      return req_predefined_action;
    }()
  }, {
    key: "req_action_stop",
    value: function () {
      var _req_action_stop = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9(sprite, script) {
        var action_id, action_value;
        return _regenerator["default"].wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              action_id = PreAction.STOP;
              action_value = 0;
              _context9.next = 1;
              return this.request('pre_action', null, {
                action_id: action_id,
                action_value: action_value
              }, true);
            case 1:
              return _context9.abrupt("return", script.callReturn());
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function req_action_stop(_x15, _x16) {
        return _req_action_stop.apply(this, arguments);
      }
      return req_action_stop;
    }()
  }, {
    key: "req_motor_control",
    value: function () {
      var _req_motor_control = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee0(sprite, script) {
        var port, motor_value, dir, motor_id, motor_dir, _t2, _t3;
        return _regenerator["default"].wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              port = script.getStringValue('MOTOR_PORT_ID');
              motor_value = script.getNumberValue('MOTOR_PORT_VALUE');
              dir = script.getStringValue('MOTOR_DIRECTION');
              _t2 = port;
              _context0.next = _t2 === 'left wheel' ? 1 : _t2 === 'right wheel' ? 2 : _t2 === 'left foot' ? 3 : _t2 === 'right foot' ? 4 : _t2 === 'left Leg' ? 5 : _t2 === 'right Leg' ? 6 : _t2 === 'left arm' ? 7 : _t2 === 'right arm' ? 8 : _t2 === 'head' ? 9 : 10;
              break;
            case 1:
              motor_id = 0;
              return _context0.abrupt("continue", 10);
            case 2:
              motor_id = 1;
              return _context0.abrupt("continue", 10);
            case 3:
              motor_id = 0;
              return _context0.abrupt("continue", 10);
            case 4:
              motor_id = 1;
              return _context0.abrupt("continue", 10);
            case 5:
              motor_id = 2;
              return _context0.abrupt("continue", 10);
            case 6:
              motor_id = 3;
              return _context0.abrupt("continue", 10);
            case 7:
              motor_id = 4;
              return _context0.abrupt("continue", 10);
            case 8:
              motor_id = 5;
              return _context0.abrupt("continue", 10);
            case 9:
              motor_id = 6;
              return _context0.abrupt("continue", 10);
            case 10:
              _t3 = dir;
              _context0.next = _t3 === 'clockwise' ? 11 : _t3 === 'counterclockwise' ? 12 : 13;
              break;
            case 11:
              motor_dir = 0;
              return _context0.abrupt("continue", 13);
            case 12:
              motor_dir = 1;
              return _context0.abrupt("continue", 13);
            case 13:
              _context0.next = 14;
              return this.request('motor_ctrl', null, {
                motor_id: motor_id,
                motor_dir: motor_dir,
                motor_value: motor_value
              }, true);
            case 14:
              return _context0.abrupt("return", script.callReturn());
            case 15:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this);
      }));
      function req_motor_control(_x17, _x18) {
        return _req_motor_control.apply(this, arguments);
      }
      return req_motor_control;
    }()
  }, {
    key: "req_line_trace",
    value: function () {
      var _req_line_trace = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee1(sprite, script) {
        var dir, line_color, line_dir, _t4;
        return _regenerator["default"].wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              dir = script.getStringField('LINE_TRACE_DIR');
              line_color = 0;
              _t4 = dir;
              _context1.next = _t4 === 'forward' ? 1 : _t4 === 'backward' ? 2 : 3;
              break;
            case 1:
              line_dir = 0;
              return _context1.abrupt("continue", 3);
            case 2:
              line_dir = 1;
              return _context1.abrupt("continue", 3);
            case 3:
              _context1.next = 4;
              return this.request('line_trace', null, {
                line_color: line_color,
                line_dir: line_dir
              }, true);
            case 4:
              return _context1.abrupt("return", script.callReturn());
            case 5:
            case "end":
              return _context1.stop();
          }
        }, _callee1, this);
      }));
      function req_line_trace(_x19, _x20) {
        return _req_line_trace.apply(this, arguments);
      }
      return req_line_trace;
    }()
  }, {
    key: "req_detect_object",
    value: function req_detect_object(sprite, script) {
      var obj = script.getStringField('OBJECT_DETECT');
      var sensor_id = 0;
      var detect_object = 0;
      if (obj === 'detected') detect_object = 1;else detect_object = 0;
      console.log(this.state.sensors);
      console.log('[req_detect_object] : ' + this.state.sensors);
      if (detect_object === 1 && this.state.sensors !== 0 && typeof this.state.sensors === 'number') {
        console.log('1111111111111111');
        return true;
      } else if (detect_object === 0 && this.state.sensors.length === 0) {
        console.log('22222222222222222');
        return true;
      } else {
        console.log('123981237980123091238079231809');
        return false;
      }
    }
  }, {
    key: "req_rfid_tag_detect",
    value: function req_rfid_tag_detect(sprite, script) {
      var tag = script.getStringField('TAG_DETECT');
      var tag_id = 0;
      switch (tag) {
        case 'circle':
          tag_id = 0;
          break;
        case 'rectangle':
          tag_id = 1;
          break;
        case 'triangle':
          tag_id = 2;
          break;
        case 'star':
          tag_id = 3;
          break;
        case 'diamond':
          tag_id = 4;
          break;
        case 'heart':
          tag_id = 5;
          break;
      }
      console.log('[req_rfid_tag_detect] : ' + tag_id + '   ' + this.state.rfid);
      if (this.state.rfid[tag_id]) {
        return true;
      } else {
        return false;
      }
    }
  }]);
}();
module.exports = {
  TelliotBase: TelliotBase,
  PreAction: PreAction
};